// extracted by mini-css-extract-plugin
module.exports = {"table":"PredictionsRawMaterialTable_table__1meUV","container":"PredictionsRawMaterialTable_container__3OuOy"};